export const stripedColors = {
  odd: '#F8F8F8',
  even: '#FFFFFF',
};

export const stripedColorsSelection = {
  odd: '#C8E5FF',
  even: '#FFFFFF',
};
